import { createContext } from 'react';

const serviceProfileContext = createContext();

export default serviceProfileContext;